import axios from 'axios';
import store from '@/store';
import AuthService from './auth.service';
import Cookies from 'js-cookie';
import {vm} from '@/main';

class HttpService {
    constructor() {
        this.generateCancelToken();

        if (HttpService.instance) {
            return HttpService.instance;
        }

        axios.interceptors.request.use((request) => {
            let locale = store.getters.locale;
            if (!locale) {
                locale = Cookies.get('locale');
            }
            if (locale) {
                request.headers.common['Accept-Language'] = locale;
            }
            if(process.env.NODE_ENV !== 'development') {
                request.baseURL = process.env.PROD_API_URL;
            }

            return request;
        });

        axios.interceptors.response.use(
            response => {
                if (response && [201, 200].includes(response.status)) {
                    return response;
                }
                return Promise.reject(response);
            },
            error => {
                if (error.response) {
                    switch (error.response.status) {
                    case 401: {
                        this.cancelRequests(error.response);
                        AuthService.logout();
                        break;
                    }
                    case 413: {
                        console.log('Attachment is too large');
                        break;
                    }
                    case 429: {
                        console.log('Too many requests');

                        this.cancelRequests(error.response);
                        AuthService.logout();
                        break;
                    }
                    case 403: {
                        vm.$router.push({name: 'dashboard'});
                        break;
                    }
                    case 404:
                    case 422: {
                        break;
                    }
                    default: {
                        break;
                    }
                    }

                    if (error.response.data) {
                        if (error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach(key => {
                                console.log('error.response.data.errors[key]');
                                console.log(error.response.data.errors[key]);
                            });
                        } else if (error.response.data.message) {
                            console.log('error.response.data.message');
                            console.log(error.response.data.message);
                            vm.$toastr.e(error.response.data.message);
                        } else {
                            console.log('Unknown error');
                        }
                    } else if (error.response.message) {
                        console.log('error.message');
                        console.log(error.message);
                    } else {
                        console.log('error');
                        console.log(error);
                    }
                    return Promise.reject(error);
                } else {
                    return Promise.reject(error);
                }
            }
        );

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        // axios.defaults.headers.common['Accept-Language'] = store.getters.locale;
        axios.defaults.withCredentials = true;

        HttpService.instance = this;
    }

    get cancelSource() {
        return this._cancelSource;
    }

    get cancelToken() {
        return this.cancelSource.token;
    }

    generateCancelToken() {
        const CancelToken = axios.CancelToken;
        this._cancelSource = CancelToken.source();
    }

    cancelRequests(message) {
        this.cancelSource.cancel(message);
        this.generateCancelToken();
    }

    get(url, options) {
        return axios.get(url, options);
    }

    post(url, body, options) {
        return axios.post(url, body, options);
    }

    put(url, body, options) {
        // const opts = {
        //     headers: {
        //         'X-HTTP-Method-Override': 'PUT'
        //     }
        // };
        return axios.put(url, body, options);
    }

    delete(url, options) {
        // const opts = {
        //     headers: {
        //         'X-HTTP-Method-Override': 'DELETE'
        //     }
        // };
        return axios.delete(url, options);
    }

    download(url) {
        return axios.get(url, { responseType: 'blob' });
    }
}

export default new HttpService();
